import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {DisplayLanguageSection} from './DisplayLanguageSection'
import {DisplaySizeSection} from './DisplaySizeSection'

export const DisplayTab = () => {
  const languages = useFeatureFlagLanguages()

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-2 items-start gap-3">
        <DisplaySizeSection />
      </div>
      <div className="grid grid-cols-2 items-start gap-3">
        {languages.map(language => (
          <DisplayLanguageSection key={language.code} language={language} />
        ))}
      </div>
    </div>
  )
}
